import { Component } from '@angular/core';

@Component({
    selector: 'app-job-costings',
    templateUrl: './job-costings.component.html',
    standalone: false,
})
export class JobCostingsComponent {}
